import { ZendeskAPI } from "react-zendesk"

export const openContactUsWidget = async () => {
    ZendeskAPI("messenger", "open")
}
